/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Stat_ProductsInputs */

const en_directory_home_hero_stat_products = /** @type {(inputs: Directory_Home_Hero_Stat_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`products launched`)
};

const zh_directory_home_hero_stat_products = /** @type {(inputs: Directory_Home_Hero_Stat_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个已发布产品`)
};

/**
* | output |
* | --- |
* | "products launched" |
*
* @param {Directory_Home_Hero_Stat_ProductsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_stat_products = /** @type {((inputs?: Directory_Home_Hero_Stat_ProductsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Stat_ProductsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_stat_products(inputs)
	return zh_directory_home_hero_stat_products(inputs)
});
export { directory_home_hero_stat_products as "directory.home.hero.stat_products" }